import React, { useContext } from 'react';
import { useLocation, useMatch } from 'react-router-dom';
import routePathSegments, { routeNames } from '../../routeSegments'
import NavbarItems from './NavbarItems'
import NavbarWrapper from './NavbarWrapper'
import { PeFilterContext } from '../../Contexts/PeFilterContext';

/** This component renders a header for a `MA` section of a
website. It uses the `useMatch` hook from the `react-router-dom` library to determine if the current
URL matches certain paths. */
function MAHeader() {
    const isCompanyMatch = useMatch({ path: `/${routePathSegments.ma}/${routePathSegments.company}/*` })
    const isAdvisorMatch = useMatch({ path: `/${routePathSegments.ma}/${routePathSegments.advisor}/*` })
    const isTransactionAdvisorMatch = useMatch({ path: `/${routePathSegments.ma}/${routePathSegments.transaction_advisor}/*` })
    const isAcquirerCompare = useMatch({path:`/${routePathSegments.compare}/${routePathSegments.acquirers}/*`})
    const isCompanyCompare = useMatch({path:`/${routePathSegments.compare}/${routePathSegments.company}/*`})
    const isAdvisorCompare = useMatch({path:`/${routePathSegments.compare}/${routePathSegments.advisor}/*`})
    const isTransactionAdvisorCompare = useMatch({path:`/${routePathSegments.compare}/${routePathSegments.transaction_advisor}/*`})
    const companyMatch = useMatch({ path: `/${routePathSegments.company}/*` })
    const isAcquirerMatch = useMatch({ path: `/${routePathSegments.ma}/${routePathSegments.acquirer}/*` })
    const isMostActiveAcquirerMatch = useMatch({ path: `/${routePathSegments.ma}/${routePathSegments.most_active_acquirers}/*` })

    const { pathname } = useLocation();
    const { refineSearchFilters } = useContext(PeFilterContext);
    const isFromGlobalSearch = () => refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false;

    return (
        <NavbarWrapper>
            <NavbarItems
                title="Companies"
                to={routeNames.MA_company}
                isLinkActive={isCompanyMatch != null || isCompanyCompare!=null || companyMatch != null}
                pageTitle="M&A Companies  - Venture Intelligence" // Pass pageTitle here
            />
            <NavbarItems
                title="Acquirers"
                to={routeNames.MA_acquirers}
                isLinkActive={isAcquirerCompare != null || isAcquirerMatch!=null || isMostActiveAcquirerMatch != null}
                pageTitle="M&A Acquirers  - Venture Intelligence" // Pass pageTitle here
            />
            <NavbarItems
            title="Legal Advisors"
            to={routeNames.MA_advisors}
            isLinkActive={isAdvisorMatch != null || isAdvisorCompare != null}
            pageTitle="M&A Advisors  - Venture Intelligence" // Pass pageTitle here
            />
            <NavbarItems
                title="Transaction Advisors"
                to={routeNames.MA_transaction_advisor}
                isLinkActive={isTransactionAdvisorMatch != null || isTransactionAdvisorCompare != null}
                pageTitle="M&A Transaction Advisors  - Venture Intelligence" // Pass pageTitle here
            />
        </NavbarWrapper>
    )
}

export default MAHeader